/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Link } from '@ta-interaktiv/contentbricks'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { ArticleTeaser } from '../articleLink'
import Stack from 'components/stack'

// TODO Set the correct article ID here
const ARTICLE_ID = '204642827651'

export function AppComponent() {
  const [stacks, setStacks] = useState<{ [key: string]: contentElement[] }>()

  useEffect(() => {
    fetch(
      'https://interaktiv.tagesanzeiger.ch/datenteam/vincenz_karteikarten_fr.json'
    )
      .then(response => response.json())
      .then((data: { [key: string]: contentElement }) => {
        const grouped: { [key: string]: contentElement[] } = {}
        Object.values(data).map(m => {
          const stapel = m.Stapel
          if (stapel) {
            if (!grouped[stapel]) grouped[stapel] = []
            grouped[stapel].push(m)
          }
        })
        setStacks(grouped)
      })
  }, [])

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>
              Les hommes et les femmes derrière le procès de Pierin Vincenz
            </h1>
            <h2>
              Ces 24 personnes ont joué un rôle important dans la saga
              Raiffeisen. Que ce soit en tant qu'accusés, adversaires ou même
              involontairement dans des rôles secondaires. Les voici présentées
              sous forme de fiches pratiques.
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>
              Jorgos Brouzos, Svenson Cornehls, Sebastian Broschinski
            </div>
            <div className='ta updated'>Mis à jour le 24 janvier, 2022</div>
          </div>
          <div className='ta text'>
            <p>
              Mardi 25 janvier <Link href='691144668875'>s’est ouvert</Link> le
              plus important des procès économiques des dernières années. Les
              principaux accusés sont l'ancien chef de Raiffeisen, Pierin
              Vincenz, et l'homme d'affaires Beat Stocker. Cinq autres personnes
              sont jugées pour complicité.
            </p>
            <p>
              De quoi s'agit-il? Vincenz et Stocker auraient secrètement pris
              des participations privées dans des entreprises proches de la
              banque Raiffeisen et de la société de cartes de crédit Aduno.
              Puis, ils auraient profité de la revente de leurs participations.
              Ensemble, ils auraient ainsi touché illégitimement 25 millions de
              francs suisses. A cela s'ajoutent des notes de frais douteuses
              pour un montant de près de 600 000 francs, dont environ un tiers
              pour des clubs de nuit.
            </p>
            <p>
              Ces 24 personnes ont joué un rôle important dans l'affaire
              Raiffeisen. Que ce soit en tant qu'accusés, complices ou
              adversaires.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          {stacks && stacks.A && (
            <Stack
              cards={stacks.A}
              title={{
                headline: 'Les accusés',
                text: (
                  <>
                    Sept personnes doivent répondre de leurs actes devant le
                    juge. Elles sont accusées par le ministère public d'avoir
                    profité, sous différentes formes, de ces affaires
                    controversées. Tous bénéficient de la présomption
                    d'innocence.
                  </>
                )
              }}
            />
          )}
        </div>
      </div>
      <div className='ui vertical segment'>
        <div className='ui text container'>
          {stacks && stacks.B && (
            <Stack
              cards={stacks.B}
              title={{
                headline: 'Les adversaires',
                text: (
                  <>
                    Ils ont soit essayé de mettre un terme aux opérations, soit
                    fait en sorte qu’elles soient révélées au public. Ils ont
                    tous agi de manière très différente.
                  </>
                )
              }}
            />
          )}
        </div>
      </div>
      <div className='ui vertical segment'>
        <div className='ui text container'>
          {stacks && stacks.C && (
            <Stack
              cards={stacks.C}
              title={{
                headline: 'Les rôles secondaires',
                text: (
                  <>
                    Ils ont pris part au scandale Raiffeisen en partie par
                    hasard, en partie par le biais d'anciennes connaissances.
                    Mais ils jouent tous un rôle décisif dans cette affaire.
                  </>
                )
              }}
            />
          )}
        </div>
      </div>
      <div className='ui vertical segment'>
        <div className='ui text container'>
          {stacks && stacks.D && (
            <Stack
              cards={stacks.D}
              title={{
                headline: 'Les supporteurs et ceux ayant détourné le regard',
                text: (
                  <>
                    Ils ne sont pas accusés dans la procédure. Mais ils ont fait
                    en sorte - involontairement ou non - que l'affaire suive son
                    cours.
                  </>
                )
              }}
            />
          )}
        </div>
        <div className='ui text container'>
          <ArticleTeaser ids={['691144668875']} />
        </div>
      </div>

      <Footer
        hidePortfolioTeaser
        articleId={ARTICLE_ID}
        credits={[
          ['Texte', 'Jorgos Brouzos'],
          ['Visualisation', 'Svenson Cornehls, Sebastian Broschinski']
        ]}
      />
    </div>
  )
}
